import React, {
  forwardRef,
  memo,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useNavigate } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Chip,
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Stack,
  Icon,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Tooltip,
  Tabs,
  Tab,
} from "@mui/material";
import clsx from "clsx";
import { makeStyles, styled } from "@mui/styles";

import jwtDecode from "jwt-decode";

import AgGridTable from "../../utilities/AgGridTable";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import ListPageHeader from "../../utilities/ListPageHeader";
import { confirmAlert } from "react-confirm-alert";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { toast } from "react-toastify";
import { grey } from "@mui/material/colors";

import moment from "moment";
import CustomDatePicker from "../../utilities/CustomDatePicker";
import FormPageHeader from "../../utilities/FormPageHeader";
import "../expense-claim/expenseClaim.css";

const useStyles = makeStyles((theme) => ({
  root: {
    "& li": {
      padding: "5px 10px",
      cursor: "pointer",

      "&:hover": {
        backgroundColor: grey[800],
      },
    },
    // borderRadius: "20px",
    fontSize: "11px",
    textAlign: "center",
    height: "26px",
    lineHeight: "26px",
    padding: "0px 10px",
    marginTop: "6px",
  },
}));

const currentDate = new Date();

const ActionRenderer = (props) => {
  return (
    <div className="flex item-center">
      <Button color="warning" variant="contained" sx={{ mr: 1 }}>
        Pay
      </Button>
      <Button color="warning" variant="contained">
        {" "}
        View
      </Button>
    </div>
  );
};

export default function Salaries(props) {
  const navigate = useNavigate();

  const classes = useStyles(props);
  const { generatePayroll } = props;

  const [payGroupOptions, setPayGroupOptions] = useState([
    { label: "All", value: "All" },
    { label: "FTP", value: "FTP" },
    { label: "FTFL", value: "FTFL" },
    { label: "PTC", value: "PTC" },
    { label: "PTH", value: "PTH" },
  ]);

  const [rowData, setRowData] = useState([
    {
      fileNo: "1",
      description: "Receipt",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
    {
      fileNo: "2",
      description: "Receipts",
      fileType: "PDF",
      filePath: "D:/container_info.txt",
    },
  ]);

  const gridRef = useRef();

  const [totalClaimed, setTotalClaimed] = useState();
  const [docUpdate, setDocUpdate] = useState(false);
  const [initialState, setInitialState] = useState({
    docNo: null,
    docDate: currentDate,
    creationDate: new Date().toISOString(),
    employeeId: null,
    employeeName: null,
    companyCode: 1,
    companyName: "Nolte FZE",
    remark: null,
    folder: [],
  });

  const [tabValue, setTabValue] = useState("nolte");
  console.log(generatePayroll);

  const [columnDefs, setColumnDefs] =
    generatePayroll === true
      ? useState([
          {
            headerName: "Employee",
            headerClass: "text-center",
            children: [
              { field: "code", headerName: "Code" },
              { field: "fullName", headerName: "Full Name" },
              { field: "department", headerName: "Department" },
            ],
          },
          {
            headerName: "Direct Payment",
            children: [
              { field: "basic", headerName: "Basic" },
              { field: "housing", headerName: "Housing" },
              { field: "transport", headerName: "Transport / Others" },
              { field: "car", headerName: "Car" },
              { field: "flight", headerName: "Flight Allowance" },
              { field: "total", headerName: "Total Per Month" },
            ],
          },
          {
            headerName: "Additions",
            children: [
              { field: "addition1", headerName: "Addition 1" },
              { field: "addition2", headerName: "Addition 2" },
              { field: "addition3", headerName: "Addition 3" },
              { field: "total", headerName: "Total Additions" },
            ],
          },
          {
            headerName: "Deductions",
            children: [
              { field: "salaryAdvance", headerName: "Salary Advance" },
              { field: "housingLoan", headerName: "Housing Loan" },
              { field: "carLoan", headerName: "Car Loan" },
              { field: "personalLoan", headerName: "Personal Loan" },
              { field: "otherLoan", headerName: "Other Loans" },
              { field: "totalLoans", headerName: "Total Loans" },
            ],
          },
          { field: "finalPayroll", headerName: "Final Payroll" },
        ])
      : useState([
          {
            headerName: "Employee",
            children: [
              { field: "code", headerName: "Code" },
              { field: "fullName", headerName: "Full Name" },
              { field: "department", headerName: "Department" },
            ],
          },
          {
            headerName: "Direct Payment",
            children: [
              { field: "basic", headerName: "Basic" },
              { field: "housing", headerName: "Housing" },
              { field: "transport", headerName: "Transport / Others" },
              { field: "car", headerName: "Car" },
              { field: "flight", headerName: "Flight Allowance" },
              { field: "total", headerName: "Total Per Month" },
            ],
          },
          {
            headerName: "Additions",
            children: [
              { field: "addition1", headerName: "Addition 1" },
              { field: "addition2", headerName: "Addition 2" },
              { field: "addition3", headerName: "Addition 3" },
              { field: "total", headerName: "Total Additions" },
            ],
          },
          {
            headerName: "Deductions",
            children: [
              { field: "salaryAdvance", headerName: "Salary Advance" },
              { field: "housingLoan", headerName: "Housing Loan" },
              { field: "carLoan", headerName: "Car Loan" },
              { field: "personalLoan", headerName: "Personal Loan" },
              { field: "otherLoan", headerName: "Other Loans" },
              { field: "totalLoans", headerName: "Total Loans" },
            ],
          },
          { field: "finalPayroll", headerName: "Final Payroll" },
          { field: "journalVoucher", headerName: "Journal Voucher" },
          { field: "bankPayment", headerName: "Bank Payment" },
          // { headerName: "Action", cellRenderer: ActionRenderer, minWidth: 200 },
        ]);

  const token = jwtDecode(localStorage.getItem("token"));

  console.log(token.scope);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const loadData = async () => {
    let email = token.email;
    const userDataUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}/search/findByEmailIgnoreCase?email=${email}`;
    const result = await OAuthService.getList(userDataUrl);
    const user = result?.data;
    const empId = user?._links.user.href.split("/").pop();

    setInitialState({
      ...initialState,
      employeeName: user?.userName,
      employeeId: empId,
      companyName: user?.companyName,
      companyCode: user?.companyId,
    });
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    setDocUpdate(urlParams.get("id") === null ? false : true);
    if (urlParams.get("id") !== null) {
      const dataUrl = `${process.env.REACT_APP_HR_API_KEY_URL}${
        oAuthServiceConfig.expenseClaimList
      }/${urlParams.get("id")}`;

      const dataVal = await OAuthService.getList(dataUrl);
      let amount = dataVal?.data?.recordList?.map((item) => {
        return item.amount;
      });
      setTotalClaimed(amount);
      setInitialState(dataVal.data);
      // setRowData(dataVal.data.recordList);
    }
  };

  const onGridReady = useCallback((params) => {
    loadData();
  }, []);

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Enter Salary",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: () => {
          navigate(`/salaryBreakdown?id=${event.node.data.code}`);
        },
      },
      {
        name: "View",
        icon: '<span><i class="material-icons" style="font-size: 18px">visibility</i></span>',
        action: () => {
          // onBtEdit(event);
        },
      },
      {
        name: "Pay",
        icon: <AttachMoneyIcon />,
        action: () => {
          // onBtDeleteRow(event);
        },
      },
    ];
    return result;
  }, []);

  const handleTabChange = (event, value) => setTabValue(value);

  return (
    <>
      <FormPageHeader
        componentName="Salaries"
        pageName={generatePayroll ? "Generate Payroll" : "Salaries"}
        currentPage={generatePayroll ? "Generate Payroll" : "Salaries"}
      />

      <div className="p-4 sm:px-24">
        <Grid container spacing={2} className="pb-6 items-center">
          {generatePayroll ? (
            <Grid xs={16} item>
              <Stack direction="row" spacing={2}>
                <Stack>
                  <label>Period</label>
                  <Stack direction="row">
                    <TextField
                      className="mb-4 w-[50px]"
                      type="text"
                      required
                      variant="outlined"
                      fullWidth
                      sx={{ mr: 2 }}
                    />
                    <TextField
                      className="mb-4 w-[100px]"
                      type="text"
                      variant="outlined"
                      fullWidth
                    />
                  </Stack>
                </Stack>
                <div className="mt-16 flex items-end">
                  <Button
                    color="warning"
                    variant="contained"
                    startIcon={
                      <FuseSvgIcon size={18}>
                        heroicons-outline:search
                      </FuseSvgIcon>
                    }
                    sx={{ mr: 1 }}
                  />

                  <Button color="warning" sx={{ mr: 1 }} variant="contained">
                    <FuseSvgIcon size={18}>
                      heroicons-outline:pencil
                    </FuseSvgIcon>
                  </Button>
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      // navigate("/payroll/generate");
                    }}
                  >
                    Finance
                  </Button>
                </div>
              </Stack>
            </Grid>
          ) : (
            <Grid xs={16} item>
              <Stack direction="row" spacing={2}>
                <Stack>
                  <label>Company</label>
                  <TextField
                    className="mb-4 w-[120px]"
                    type="text"
                    required
                    variant="outlined"
                    fullWidth
                  />
                </Stack>
                <Stack>
                  <span>Date From</span>
                  <CustomDatePicker
                    className="mb-4 w-[160px]"
                    format={"dd-MM-yyyy"}
                    name={"fromDate"}
                  />
                </Stack>
                <Stack>
                  <label>Date To</label>
                  <CustomDatePicker
                    className="mb-4 w-[150px]"
                    name={"creationDate"}
                    format={"dd-MM-yyyy"}
                    fullWidth
                  />
                </Stack>
                <Stack className="mr-16">
                  <label>Pay Group</label>

                  <Select
                    className="w-[150px]"
                    name="pay_group"
                    defaultValue={payGroupOptions[0]}
                    options={payGroupOptions}
                    styles={customStyles()}
                  />
                </Stack>

                <div className="mt-16 flex items-end">
                  <Button
                    color="warning"
                    variant="contained"
                    startIcon={
                      <FuseSvgIcon size={18}>
                        heroicons-outline:search
                      </FuseSvgIcon>
                    }
                    sx={{ mr: 1 }}
                  />

                  {/* <Button color="warning" sx={{ mr: 1 }} variant="contained">
                    Clear
                  </Button> */}
                  <Button
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      navigate("/generate");
                    }}
                  >
                    Generate Payroll
                  </Button>
                </div>
              </Stack>
            </Grid>
          )}
        </Grid>
      </div>

      <div className="h-full">
       <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: "w-full border-b-1" }}
          className={clsx(classes.root)}
        >
          <Tab 
            label="FTP (2)" 
            value={"nolte"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="FTFL(3)" 
            value={"free-lance"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="PTC (21)" 
            value={"it-consultant"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
          <Tab 
            label="PTH (21)" 
            value={"it-consultant"} 
            sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} 
          />
        </Tabs>

        <AgGridTable
          hideCheckbox={generatePayroll ? false : true}
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          rowGroupPanelShow="never"
          getContextMenuItems={getContextMenuItems}
        />
      </div>
    </>
  );
}
